export const PhoneFrame = ({ children, accent = "#0066FF", className = "" }) => (
  <div
    className={`relative mx-auto w-[220px] sm:w-[240px] rounded-[2.1rem] border-[3px] border-slate-700/70 bg-[#05060c] p-2 shadow-2xl ${className}`}
    style={{ boxShadow: `0 0 50px -12px ${accent}55` }}
  >
    <div className="absolute left-1/2 top-2.5 -translate-x-1/2 h-1.5 w-14 rounded-full bg-slate-800 z-10" />
    <div className="relative rounded-[1.6rem] overflow-hidden bg-card-dark aspect-[9/18.5] flex flex-col">
      {children}
    </div>
  </div>
);

const Chip = ({ children }) => (
  <span className="px-2 py-1 rounded-full bg-electric/15 text-laser border border-electric/30 text-[7px] sm:text-[8px] whitespace-nowrap font-medium">
    {children}
  </span>
);

export const MyKitchenScreen = () => (
  <div className="flex h-full flex-col">
    <div className="flex items-center justify-between px-3 pt-4 pb-2">
      <span className="font-display font-bold text-white text-[11px]">My Kitchen</span>
      <div className="h-5 w-5 rounded-full bg-orange-500/20 border border-orange-400/40" />
    </div>
    <div className="mx-3 mb-2 h-6 rounded-full bg-white/5 border border-white/10 flex items-center px-2 text-[8px] text-slate-500">
      Search meals & subscriptions
    </div>
    <div className="flex gap-1.5 px-3 mb-2">
      <Chip>Meals</Chip>
      <Chip>Subscriptions</Chip>
      <Chip>Combo</Chip>
    </div>
    <div className="flex-1 px-3 space-y-2">
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="flex items-center gap-2 rounded-xl bg-white/[0.03] border border-white/5 p-2"
        >
          <div className="h-9 w-9 rounded-lg bg-gradient-to-br from-orange-400/40 to-red-500/20 border border-white/10 shrink-0" />
          <div className="flex-1 space-y-1">
            <div className="h-1.5 w-16 rounded bg-slate-500/80" />
            <div className="h-1.5 w-10 rounded bg-slate-700" />
          </div>
          <div className="h-5 w-8 rounded-full bg-laser/15 border border-laser/40 text-laser flex items-center justify-center text-[7px] shrink-0">
            Add
          </div>
        </div>
      ))}
    </div>
    <div className="flex justify-around border-t border-white/5 py-2.5">
      {["Home", "Orders", "Subs", "Profile"].map((t) => (
        <span key={t} className="text-[7px] text-slate-500">
          {t}
        </span>
      ))}
    </div>
  </div>
);

export const Click2HomeScreen = () => (
  <div className="flex h-full flex-col">
    <div className="flex items-center justify-between px-3 pt-4 pb-2">
      <span className="font-display font-bold text-white text-[11px]">Click2Home</span>
      <div className="h-5 w-5 rounded-full bg-electric/20 border border-electric/40" />
    </div>
    <div className="grid grid-cols-4 gap-1.5 px-3 mb-2.5">
      {["Electric", "Plumb", "AC", "Clean"].map((t) => (
        <div key={t} className="flex flex-col items-center gap-1">
          <div className="h-8 w-8 rounded-xl bg-electric/10 border border-electric/30" />
          <span className="text-[6px] text-slate-500">{t}</span>
        </div>
      ))}
    </div>
    <div className="flex-1 px-3 space-y-2">
      {[0, 1].map((i) => (
        <div
          key={i}
          className="flex items-center gap-2 rounded-xl bg-white/[0.03] border border-white/5 p-2"
        >
          <div className="h-8 w-8 rounded-full bg-gradient-to-br from-electric/40 to-laser/20 border border-white/10 shrink-0" />
          <div className="flex-1 space-y-1">
            <div className="h-1.5 w-16 rounded bg-slate-500/80" />
            <div className="h-1.5 w-12 rounded bg-slate-700" />
          </div>
          <div className="h-5 w-11 rounded-full bg-laser/15 border border-laser/40 text-laser flex items-center justify-center text-[7px] shrink-0">
            Book
          </div>
        </div>
      ))}
    </div>
    <div className="mx-3 mb-3 h-16 rounded-xl bg-gradient-to-br from-electric/10 to-transparent border border-white/5 relative overflow-hidden">
      <div className="absolute top-3 left-4 h-1.5 w-1.5 rounded-full bg-laser" />
      <div className="absolute top-7 left-9 h-1.5 w-1.5 rounded-full bg-electric" />
      <div className="absolute bottom-3 right-6 h-1.5 w-1.5 rounded-full bg-laser" />
      <span className="absolute bottom-1.5 left-2 text-[6px] text-slate-500">Nearby technicians</span>
    </div>
  </div>
);

export const LabourMarketplaceScreen = () => (
  <div className="flex h-full flex-col">
    <div className="flex items-center justify-between px-3 pt-4 pb-2">
      <span className="font-display font-bold text-white text-[11px]">Labour Market</span>
      <div className="h-5 w-5 rounded-full bg-laser/20 border border-laser/40" />
    </div>
    <div className="flex gap-1.5 px-3 mb-2 overflow-hidden">
      <Chip>Mason</Chip>
      <Chip>Carpenter</Chip>
      <Chip>Painter</Chip>
    </div>
    <div className="flex-1 px-3 space-y-2">
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="flex items-center gap-2 rounded-xl bg-white/[0.03] border border-white/5 p-2"
        >
          <div className="h-9 w-9 rounded-full bg-gradient-to-br from-laser/30 to-electric/20 border border-white/10 shrink-0" />
          <div className="flex-1 space-y-1">
            <div className="h-1.5 w-14 rounded bg-slate-500/80" />
            <div className="flex gap-1">
              <span className="h-1.5 w-6 rounded bg-slate-700" />
              <span className="h-1.5 w-6 rounded bg-slate-700" />
            </div>
          </div>
          <div className="h-5 w-14 rounded-full bg-electric/15 border border-electric/40 text-laser flex items-center justify-center text-[6.5px] shrink-0">
            View
          </div>
        </div>
      ))}
    </div>
    <div className="flex justify-around border-t border-white/5 py-2.5">
      {["Discover", "Saved", "Jobs", "Profile"].map((t) => (
        <span key={t} className="text-[7px] text-slate-500">
          {t}
        </span>
      ))}
    </div>
  </div>
);

export const PROJECT_SCREENS = {
  myKitchen: MyKitchenScreen,
  click2Home: Click2HomeScreen,
  labourMarketplace: LabourMarketplaceScreen,
};
